import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchases } from '../data/purchases';
import { OFFER_ANCHOR } from './constants';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimer: number;
    const cycle = () => {
      showTimer = window.setTimeout(() => {
        setVisible(true);
        window.setTimeout(() => {
          setVisible(false);
          setIndex(prev => (prev + 1) % purchases.length);
        }, 5000);
      }, 3500);
    };
    cycle();
    return () => window.clearTimeout(showTimer);
  }, [index, dismissed]);
  const purchase = purchases[index];
  return <AnimatePresence data-id="element-130" data-mp="1cvr2nxe5v0l7">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-3 left-3 z-50 w-[248px] rounded-xl border-2 border-mustard bg-white p-2.5 shadow-[0_10px_24px_-8px_rgba(7,63,54,0.45)] sm:w-[280px]" role="status" aria-live="polite" data-id="element-131" data-mp="1gxvtyph4zl4o">
          <button type="button" onClick={() => setDismissed(true)} className="absolute right-1.5 top-1.5 rounded p-0.5 text-graphite/50 transition-colors duration-150 hover:text-graphite" aria-label="Chiudi notifica" data-id="element-132" data-mp="n6lj1msvjyu9">
            <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-133" data-mp="s67ubqp5750f" />
          </button>
          <a href={OFFER_ANCHOR} className="flex items-start gap-2 pr-4" data-id="element-134" data-mp="s8kkus8yunp3">
            <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-terracotta text-white" data-id="element-135" data-mp="28iwnqu35r8sv">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-136" data-mp="23npnjw93km8p" />
            </span>
            <span className="min-w-0" data-id="element-137" data-mp="2aqntgu81pz6e">
              <span className="block font-display text-[11px] font-extrabold uppercase leading-tight text-petrol" data-id="element-138" data-mp="2fn4rcg51rrwo">
                {purchase.name} — {purchase.city}
              </span>
              <span className="block text-[11px] leading-snug text-graphite" data-id="element-139" data-mp="2plk8bqad1ksg">
                {purchase.region} · ha appena acquistato LOGOPEDIA PRO™
              </span>
              <span className="mt-0.5 block text-[10px] font-semibold uppercase tracking-wide text-mustard" data-id="element-140" data-mp="1rvz4vi4lq1de">
                Pochi minuti fa
              </span>
            </span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}